import React, { useReducer } from "react";
import { v4 } from "uuid";
import AlertContext from "./AlertContext";
import AlertReducer from "./AlertReducer";
import { SET_ALERT, REMOVE_ALERT, CLEAR_ALERT } from "../types";

const AlertState = (props) => {
  const initialState = [];

  const [state, dispatch] = useReducer(AlertReducer, initialState);

  // Set Alert
  const setAlert = (msg, type, timeout = 5000) => {
    const id = v4();

    let newMsg = true;

    for (var x in state) {
      if (msg === state[x].msg) {
        newMsg = false;
      }
    }

    if (newMsg) {
      dispatch({
        type: SET_ALERT,
        payload: {
          msg,
          type,
          id,
        },
      });

      setTimeout(
        () =>
          dispatch({
            type: REMOVE_ALERT,
            payload: id,
          }),
        timeout
      );
    }
  };

  const clearAlert = () => {
    dispatch({
      type: CLEAR_ALERT,
    });
  };

  return (
    <AlertContext.Provider
      value={{
        alerts: state,
        setAlert,
        clearAlert,
      }}
    >
      {props.children}{" "}
    </AlertContext.Provider>
  );
};

export default AlertState;
